export const REQUEST_MODES = [
    { id: 'new', title: 'Новый запрос' },
    { id: 'change', title: 'Изменение запроса' }
];
export function requestModeTitle(mode) {
    return REQUEST_MODES.find((m) => m.id === mode).title;
}
export const REQUEST_COLUMNS = [
    { key: 'art', title: 'OEM', width: 170, format: 'text', required: true },
    { key: 'name', title: 'Наименование', width: 300, format: 'text' },
    { key: 'qty', title: 'Количество, шт', width: 120, format: 'int', required: true },
    { key: 'price', title: 'Цена продажи, CNY', width: 140, format: 'money' },
    { key: 'note', title: 'Примечание', width: 240, format: 'text' }
];
export function requestFieldTexts(mode) {
    return {
        reqNo: {
            label: '№ запроса',
            hint: mode === 'new' ? 'Уникальный номер нового запроса' : 'Выберите номер — состав загрузится сам',
            required: true
        },
        date: {
            label: 'Дата',
            hint: mode === 'new' ? 'Дата таблицы клиента (пусто — сегодня)' : 'Дата правки (пусто — сегодня)',
            required: false
        },
        deadline: {
            label: 'Срок поставки',
            hint: 'Заполняется позже, когда срок станет известен',
            required: false
        },
        comment: { label: 'Комментарий', hint: 'Необязательно', required: false }
    };
}
export function requestInstructions(mode) {
    if (mode === 'new') {
        return [
            'Заполните номер запроса и вставьте таблицу клиента: OEM, наименование, количество, цена.',
            'Цена — та, по которой продаём клиенту. По ней считаются суммы и маржа.',
            'Номер должен быть новым: если такой запрос уже есть, переключитесь в режим «Изменение запроса».'
        ];
    }
    return [
        'Выберите номер запроса — текущий состав загрузится в таблицу.',
        'Поправьте количества и цены, добавьте новые строки. Чтобы снять позицию, поставьте количество 0 или удалите строку.',
        'Можно вставить новую таблицу клиента целиком: позиций, которых в ней нет, станет 0.',
        'Если запрос нужно закрыть частично, поставьте нужные количества — остальное останется в работе.'
    ];
}
//# sourceMappingURL=columns.js.map